// @ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import SoftTypography from "../../components/common/softTypography";
import { FaUserCircle } from "react-icons/fa";
import SoftButton from "../../components/common/softButton";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import { getChatData, sendMessageData } from "../../features/chat";
import SoftInput from "../../components/common/softInput";
import { FaPaperPlane } from "react-icons/fa6";
import { userTable } from "../../features/auth";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import { useNavigate, useParams } from "react-router-dom";
import socket from "../../utils/Socket";
import { FiPaperclip } from "react-icons/fi";
const Chat = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const chatEndRef = useRef(null);
  const loginUser = useMemo(() => {
    return localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
  }, []);
  const [userList, setUserList] = useState([]);
  const { users } = useAppSelector((state) => state.auth);
  const { data: messages, status } = useAppSelector((state) => state.chat);

  const [selectedUser, setSelectedUser] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    dispatch(userTable({ page: 1, limit: 100, userType: "user" }));
  }, [dispatch]);

  useEffect(() => {
    // // console.log(users?.data, "users");
    if (users && users?.data?.length) {
      setUserList(users?.data);
    }
  }, [status, users]);

  useEffect(() => {
    if (userList && userList?.length) {
      if (id && id !== ":id") {
        // console.log(id, "id");

        setSelectedUser(id);
      } else {
        // console.log({ userList });

        let selectedUser = userList[0]?._id;
        setSelectedUser(selectedUser);
        // console.log(selectedUser, "selectedUseri");

        navigate(`/customer-support/${selectedUser}`, { replace: true });
      }
    }
  }, [dispatch, id, userList]);

  useEffect(() => {
    // // console.log(loginUser, "loginUseri");
    // // console.log(selectedUser, "selectedUseri");
    if (loginUser && loginUser?._id && selectedUser) {
      dispatch(getChatData({ user1: loginUser?._id, user2: selectedUser }));
    }
  }, [dispatch, loginUser, selectedUser]);

  useEffect(() => {
    socket.emit("join", loginUser?._id);

    socket.on("receive_message", (data) => {
      // console.log(data, "receive_message");
    });

    return () => {
      socket.off("receive_message");
    };
  }, []);

  const handleSendMessage = () => {
    // // console.log(newMessage,'newMessage')
    if (!newMessage.trim()) return;
    // let mediaUrl = null;

    // // Upload media via REST API
    // if (media) {
    //   const formData = new FormData();
    //   formData.append("file", media);
    //   const res = await fetch("http://localhost:5000/api/upload", {
    //     method: "POST",
    //     body: formData,
    //   });
    //   const result = await res.json();
    //   mediaUrl = result.url;
    // }

    const newMessage1 = {
      senderId: loginUser?._id,
      receiverId: selectedUser,
      message: newMessage,
      mediaUrl: "",
    };

    socket.emit("send_message", newMessage1);
    dispatch(sendMessageData({ receiver: selectedUser, message: newMessage }));
    setNewMessage("");
    dispatch(getChatData({ user1: loginUser?._id, user2: selectedUser }));





    
    // file upload
    if (!newMessage && !selectedFile) return;

    const messageData = {
      text: newMessage,
      file: selectedFile,
      timestamp: new Date(),
    };

    // console.log("Sending message:", messageData);

    setNewMessage("");
    setSelectedFile(null);
  };

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [selectedUser, messages?.length]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox display="flex" height="81vh" bgColor="white">
        {/* User List Sidebar */}
        <SoftBox
          width={{ xs: "100%", md: "25%" }}
          bgColor="white"
          p={2}
          borderRight="1px solid #ddd"
          overflow="auto"
        >
          <SoftBox
            fontSize="16px"
            fontWeight="semibold"
            px={1}
            pb={1}
            mb={1}
            borderBottom={"1px solid #eee"}
            borderRadius={"0px"}
          >
            Chats
          </SoftBox>
          {userList &&
            userList.length &&
            userList.map((user) => (
              <SoftBox
                key={user._id}
                display="flex"
                alignItems="center"
                p={1}
                borderRadius="md"
                cursor="pointer"
                bgColor={selectedUser === user._id ? "primary" : "transparent"}
                color={selectedUser === user._id ? "white" : "black"}
                onClick={() =>
                  navigate(`/customer-support/${user._id}`, { replace: true })
                }
              >
                <SoftBox
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50px",
                    overflow: "hidden",
                    backgroundColor:
                      selectedUser === user._id ? "#fff" : "#f0f0f0",
                  }}
                >
                  {user?.profileImage ? (
                    <img
                      src={user.profileImage}
                      alt="User Image"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <FaUserCircle size={24} />
                  )}
                </SoftBox>
                <SoftBox
                  color={selectedUser === user._id ? "white" : "black"}
                  mx={1}
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                    textTransform: "capitalize",
                  }}
                >
                  {user?.owner_name || ""} -{user?.email || ""}
                </SoftBox>
              </SoftBox>
            ))}
        </SoftBox>

        {/* Chat Box */}
        <SoftBox flex={1} display="flex" flexDirection="column">
          <SoftBox flex={1} overflow="auto" p={3}>
            {messages && messages?.length ? (
              messages.map((msg, index) => (
                <SoftBox
                  key={index}
                  p={2}
                  borderRadius="md"
                  mb={2}
                  bgColor={msg.sender === selectedUser ? "primary" : "grey-200"}
                  color={msg.sender === selectedUser ? "white" : "black"}
                  alignSelf={
                    msg.sender === selectedUser ? "flex-end" : "flex-start"
                  }
                  ref={chatEndRef}
                >
                  {msg.message}
                </SoftBox>
              ))
            ) : (
              <SoftBox
                display="flex"
                height={"100%"}
                flex={1}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <SoftTypography
                  variant="button"
                  tag="h3"
                  fontWeight="normal"
                  textTransform="capitalize"
                >
                  No Data Found!!
                </SoftTypography>
              </SoftBox>
            )}
            <div />
          </SoftBox>

          {/* Message Input */}
          <SoftBox
            display="flex"
            alignItems="center"
            style={{
              columnGap: "10px",
              borderTop: "1px solid #ddd",
              borderRadius: 0,
              padding: "24px",
            }}
          >
            <SoftBox sx={{ width: "100%", position: "relative" }}>
              <SoftInput
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={(e) => {
                  if (e.which === 13) {
                    handleSendMessage();
                  }
                }}
                sx={{ pr: "40px" }}
                placeholder="Type a message..."
                flex={1}
              />
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  // console.log("Selected file:", file);
                }}
              />
              <FiPaperclip
                className="attachment-icon"
                size={20}
                onClick={() => {
                  document.getElementById("fileInput").click();
                }}
              />
            </SoftBox>
            <SoftButton
              variant="gradient"
              color="info"
              onClick={handleSendMessage}
            >
              <FaPaperPlane size={18} />
            </SoftButton>
          </SoftBox>
        </SoftBox>
        {selectedFile && (
          <SoftBox mt={2}>
            <img
              src={URL.createObjectURL(selectedFile)}
              alt="preview"
              style={{ maxHeight: "100px", borderRadius: "8px" }}
            />
          </SoftBox>
        )}
      </SoftBox>
    </DashboardLayout>
  );
};

export default Chat;
